export const ORIENTATION_COLORS = {
  Care: "#10b981",
  Utility: "#3b82f6",
  Creative: "#8b5cf6",
  Extraction: "#ef4444",
};

export const TYPES = [
  { id: "countries", label: "Countries" },
  { id: "regions", label: "Regions" },
  { id: "orientations", label: "Orientations" },
  { id: "form_factors", label: "Form Factors" },
];

export const FILTERS = [
  { id: "", label: "Universe" },
  { id: "application", label: "Software" },
  { id: "device", label: "Hardware" },
];

export const LOADING_MESSAGES = [
  "Aggregating data sources...",
  "Computing orientation indices...",
  "Analyzing founder diversity...",
  "Generating narrative insights...",
];
